<template>
    <div>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="客户名称" prop="nonull">
          <el-input  v-model="ruleForm.cusname" placeholder="请输入客户名称"></el-input>
        </el-form-item>
        <el-form-item label="营业执照号" prop="nonull">
          <el-input v-model="ruleForm.blnum" placeholder="请输入营业执照编号（三证合一）"></el-input>
        </el-form-item>
        <el-form-item label="上传营业执照" class="yyzz_upload">
          <BaseUpLoadFile @upok="upzm" :ifimg="ifimg" :curfilepath="yyzzpath" bucketpath="cus"></BaseUpLoadFile>
        </el-form-item>
        <div class="savebasepanel">
          <el-button type="primary" @click="savenext('ruleForm')">下一步</el-button>
        </div>
      </el-form>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import BaseUpLoadFile from '../upload/BaseUpLoadFile'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'UpCusOne',
    components: {BaseUpLoadFile},
    data () {
      var validateNull = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('不允许为空'));
        } else {
          callback();
        }
      }
      return {
        ifimg: true,
        yyzzpath: '',
        ruleForm: {
          cusname: '',
          blnum: ''
        },
        rules: {
          nonull: [
            { validator: validateNull, trigger: 'blur' }
          ]
        }
      }
    },
    mounted () {
      document.title = '企业注册'
      that = this
    },
    methods: {
      upzm (path) {
        this.yyzzpath = path
      },
      savenext (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var adata = {
              name: that.ruleForm.cusname,
              blnum: {String: this.ruleForm.blnum, Valid: true},
              blinstitutionnum: {String: this.ruleForm.blnum, Valid: true},
              blcreditnum: {String: this.ruleForm.blnum, Valid: true},
              blnumurl: {String: this.yyzzpath, Valid: true},
              blinstitutionurl: {String: this.yyzzpath, Valid: true},
              raddress: {String: '', Valid: true},
              maddress: {String: '', Valid: true},
              validdate: {String: '', Valid: true},
              lpname: {String: '', Valid: true},
              lpid: {String: '', Valid: true},
              lpidurl: {String: '', Valid: true},
              lpidbackurl: {String: '', Valid: true},
              lpcontact: {String: '', Valid: true},
              ownerid: {Int64: parseInt(1), Valid: true}
            }
            that.$http({
              url: 'https://api.sqnetsoft.cn/customer/addcus',
              method: 'post',
              data: adata,
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(function (res) {
                console.log(res)
                if (res.data.success) {
                  localStorage.setItem('regcusid',res.data.data)
                  localStorage.setItem('regcustep',2)
                  that.$emit('regtwo');
                  that.$message({
                    type: 'success',
                    message: '添加成功!'
                  })
                } else {
                  that.$message({
                    type: 'error',
                    message: '添加失败!'
                  })
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regedit/UpCusOne.vue